<template>
  <footer class="">
    <nav class="foot_nav">
<!--      <router-link tag="a" :to="{ path: '/scopeindex' }" @click.native="changePage(1)" :class="currentNav == 1 ? 'on' : ''" replace>商城</router-link>
      <router-link tag="a" :to="{ path: '/myorder' }" @click.native="changePage(2)" :class="currentNav == 2 ? 'on' : ''" replace>订单</router-link>
      <router-link tag="a" :to="{ path: '/myuser' }" @click.native="changePage(3)" :class="currentNav == 3 ? 'on' : ''" replace>我的</router-link> -->
      <span @click="changePage(1)" :class="currentNav == 1 ? 'on' : ''" replace class="navDiv">
        <i class="iconfont_new icon-dianpu navIcon"></i>
        <p>首页</p>
      </span>
      <span @click="changePage(2)" :class="currentNav == 2 ? 'on' : ''" replace class="navDiv"> 
        <i class="iconfont_new icon-yongfa navIcon"></i>
        <p>订单</p>
      </span>
      <span @click="changePage(3)" :class="currentNav == 3 ? 'on' : ''" replace class="navDiv">
        <i class="iconfont_new icon-wode2 navIcon"></i>
        <p>我的</p>
      </span>
    </nav>
  </footer>
</template>

<script>
export default {
  name: 'NavFooter',
  data() {
    return {
      currentNav: 1
    };
  },
  methods: {
    changePage(val) {
      this.currentNav = val;
      this.$emit('changePage', val);
    }
  }
};
</script>

<style scoped="scoped" lang="less">
  @import '../../style/public';
  @import "../../style/home.less";
  .foot_nav{
    color:#aaaaaa;
    border-top:1px solid #eaeaea;
    .flex_wrap();
    &>span{
      flex: 1;
      text-align: center;
      .inlLh(1.4rem);
      &.on{.colorprimary;}
    }
  }

  .navIcon{
    font-size: 0.6rem;
  }
  .navDiv{
    line-height:0.5rem!important;
    padding: 0.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/child-components/NavFooter.vue